/** Gli errori del database non sono Error ma oggetti con un messaggio: vanno letti anche quelli. */
export function messaggioErrore(errore: unknown): string {
  if (errore instanceof Error) return errore.message;
  if (errore && typeof errore === 'object' && 'message' in errore) return String(errore.message);
  return 'Errore imprevisto.';
}
